import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";

const PasswordProtection = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState("");

    useEffect(() => {
        if (localStorage.getItem("authenticated") === "true") {
            setIsAuthenticated(true);
        }
    }, []);

    const handleLogin = () => {
        if (password === process.env.REACT_APP_PASSWORD) {
            localStorage.setItem("authenticated", "true");
            setIsAuthenticated(true);
        } else {
            alert("Falsches Passwort!");
        }
    };

    if (!isAuthenticated) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
                <Typography variant="h5">🔒 Zugang gesperrt</Typography>
                <TextField
                    type="password"
                    label="Passwort"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    margin="normal"
                />
                <Button variant="contained" color="primary" onClick={handleLogin}>
                    Login
                </Button>
            </Box>
        );
    }

    return children;
};

export default PasswordProtection;
